"use client";

import React from "react";
import { Soup, Coffee, HandHeart, Heart, Baby, Milk, Moon, House as Home, MessageCircle } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
interface ServiceItem {
  id: string;
  icon: React.ComponentType<{
    className?: string;
  }>;
  title: string;
  description: string;
}
const serviceItems: ServiceItem[] = [{
  id: "meals",
  icon: Soup,
  title: "Repas & collations maison",
  description: "Des repas chauds et nourrissants, des collations spécifiques au post-partum."
}, {
  id: "home-aid",
  icon: Home,
  title: "Aide légère à la maison",
  description: "Un peu de linge, de rangement et de soutien avec les aînés lorsque nécessaire."
}, {
  id: "rituals",
  icon: Coffee,
  title: "Petits rituels réconfortants",
  description: "Tisanes et bains de pieds aux plantes pour t'offrir une pause."
}, {
  id: "treatments",
  icon: HandHeart,
  title: "Soins bien être",
  description: "Massages, réflexologie plantaire, bandage et resserage du bassin, selon tes besoins."
}, {
  id: "listening",
  icon: Heart,
  title: "Écoute & soutien émotionnel",
  description: "Un espace pour déposer ce que tu traverses et revenir sur ton vécu de naissance si tu le souhaites."
}, {
  id: "baby-care",
  icon: Baby,
  title: "Relais avec bébé",
  description: "Du temps pour dormir, prendre une douche, manger tranquillement ou simplement souffler."
}, {
  id: "feeding",
  icon: Milk,
  title: "Allaitement & biberon",
  description: "Du soutien autour de l'alimentation de ton bébé et de tes questions."
}, {
  id: "sleep",
  icon: Moon,
  title: "Sommeil & quotidien",
  description: "Des repères pour mieux comprendre le sommeil et le quotidien avec bébé."
}, {
  id: "connection",
  icon: MessageCircle,
  title: "Un lien entre les visites",
  description: "Du soutien WhatsApp pendant toute la durée de ton accompagnement."
}];
export default function IncludedServices() {
  return <section id="inclus-accompagnement" data-nav="light" className="relative bg-[#43362F] text-[#FCFAF7] py-20 md:py-28 lg:py-32">
      <div className="container mx-auto px-6 max-w-6xl">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-20">
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-[44px] leading-tight text-[#FCFAF7] font-normal tracking-normal mb-5">Inclus dans ton forfait&nbsp;</h2>
          <p className="text-[#FCFAF7]/80 text-base md:text-lg leading-relaxed font-default font-normal max-w-2xl mx-auto">Du soutien concret, des soins et des moments de reconnection au corps, de la cuisine postnatale et une présence attentive. Chaque visite s'adapte à ce dont tu as besoin ce jour-là.</p>
        </div>

        {/* 9 Items Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-12 lg:gap-x-12 lg:gap-y-16">
          {serviceItems.map((item, i) => {
          const IconComponent = item.icon;
          return <div key={item.id} data-index={i} className="flex items-start gap-4 sm:gap-5">
                <div className="shrink-0 text-[#A77B62] pt-0.5" aria-hidden="true">
                  <IconComponent className="size-7 sm:size-8" />
                </div>
                <div className="space-y-2">
                  <h3 className="font-serif text-xl sm:text-[22px] lg:text-2xl text-[#FCFAF7] font-medium leading-snug">
                    {item.title}
                  </h3>
                  <p className="text-[#FCFAF7]/80 text-sm sm:text-base leading-relaxed font-default">
                    {item.description}
                  </p>
                </div>
              </div>;
        })}
        </div>

        {/* Closing & CTA */}
        <div className="mt-16 sm:mt-20 lg:mt-24 text-center max-w-2xl mx-auto flex flex-col items-center">
          <p className="text-[#FCFAF7]/85 text-base sm:text-lg leading-relaxed font-default mb-8 sm:mb-10">
            Nous choisissons ensemble ce qui te ferait le plus de bien. Ces possibilités s&apos;intègrent au temps de tes visites, sans programme imposé.
          </p>

          <Button asChild size="lg" className="border border-[#A77B62]/70 bg-transparent text-[#FCFAF7] hover:bg-[#A77B62] hover:text-[#43362F] hover:border-[#A77B62] rounded-full px-8 py-3 text-xs sm:text-sm tracking-wider uppercase transition-colors shadow-xs">
            <Link to="#forfaits-postpartum">
              CHOISIR MON FORFAIT →
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}